
import React from 'react'
import {Link}from 'react-router-dom'
import menuButton from '../assets/img/12.jpeg'
// import ToggleDark from './ToggleDark'
const Navbar  = () => {


    return (
	
	<>
	<a href="three.html">Three Scene</a>

					<ul className=' nav-links'>


					<li>
					<Link to='#' className='active'>Home</Link>
					
				</li>

				<li>
					<Link to='/hire'  className='Link'>Hire</Link>
					
				</li>


				<li>
					<Link to='/openai/m1/select' className='Link'>OpenAI</Link>
				</li>
			
							

				 <li>
					<Link to='/picture-book' className='Link'>Gallery</Link>
				</li>
							
	
					<li>				
						<Link to='/blog'  className='Link'>Blog</Link>
					</li>

			</ul>	


<h3 className='portfolio-absolute transition-5'>Portfolio</h3>

</>
	    
	)}
export default Navbar;